webpackJsonp([3],{

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

var _jobfinder = __webpack_require__(38);

var _jobfinder2 = _interopRequireDefault(_jobfinder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)(document).ready(function () {
  var jobFinder = new _jobfinder2.default();

  jobFinder.init();
});

/***/ }),

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

__webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _class = function () {
  function _class() {
    _classCallCheck(this, _class);
  }

  _createClass(_class, [{
    key: 'init',
    value: function init() {
      this.initSelects();
    }
  }, {
    key: 'initSelects',
    value: function initSelects() {
      var employmentTypeSelect = (0, _jquery2.default)('#me-umantis-field-filter-employment-type');
      var jobTypeSelect = (0, _jquery2.default)('#me-umantis-field-filter-job-type');
      var locationSelect = (0, _jquery2.default)('#me-umantis-field-filter-location');

      employmentTypeSelect.select2({
        allowClear: true,
        dropdownAutoWidth: true,
        placeholder: employmentTypeSelect.data('placeholder'),
        dropdownCssClass: 'dropdown--product',
        width: '100%'
      });

      employmentTypeSelect.on('select2:open', function () {
        (0, _jquery2.default)('.select2-search--dropdown .select2-search__field').attr('placeholder', employmentTypeSelect.data('placeholder-inline'));
      });

      employmentTypeSelect.on('select2:close', function () {
        (0, _jquery2.default)('.select2-search--dropdown .select2-search__field').attr('placeholder', null);
      });

      jobTypeSelect.select2({
        allowClear: true,
        dropdownAutoWidth: true,
        placeholder: jobTypeSelect.data('placeholder'),
        dropdownCssClass: 'dropdown--product',
        width: '100%'
      });

      jobTypeSelect.on('select2:open', function () {
        (0, _jquery2.default)('.select2-search--dropdown .select2-search__field').attr('placeholder', jobTypeSelect.data('placeholder-inline'));
      });

      jobTypeSelect.on('select2:close', function () {
        (0, _jquery2.default)('.select2-search--dropdown .select2-search__field').attr('placeholder', null);
      });

      locationSelect.select2({
        placeholder: locationSelect.data('placeholder'),
        width: '100%',
        dropdownCssClass: 'dropdown--product',
        dropdownAutoWidth: true
      });
    }
  }]);

  return _class;
}();

exports.default = _class;

/***/ })

},[37]);


// WEBPACK FOOTER //
// ../htdocs/web/fileadmin/career/js/dist/jobfinder.min.js